import { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from "react-router-dom";
import { IzobrazevanjeListType } from "../../types/Izobrazevanje/IzobrazevanjeListType";
import { IzobrazevanjeFormType } from "../../types/Izobrazevanje/IzobrazevanjeFormType";
import { IzobrazevanjeWithSifrantiType } from "../../types/Izobrazevanje/IzobrazevanjeWithSifrantiType";
import { IzobrazevanjeDetailType } from "../../types/Izobrazevanje/IzobrazevanjeDetailType";
import { useContext } from "react";
import { FeedbackContext, Status } from "../../context/FeedbackContext";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";
import client from "../../services/client";
//import { getFormDataFromObject } from "../../utils/Common";
import { keyframes } from "styled-components";
import { resolvePtr } from "dns";
import { IzobrazevanjeVrsta } from "../../utils/Enums";
//import { IzobrazevanjeJavnoFormType } from "../../types/Izobrazevanje/IzobrazevanjeJavnoFormType";

// TODO: ena funkcija, ki izvaja klice, da se ne podvaja logika za vse klice

const useFetchIzobrazevanjeAll = () => {
    return useQuery<IzobrazevanjeListType[], AxiosError>(["izobrazevanja"], async () => {
        try {
            return (await client.get(`izobrazevanje/all`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
};

const useFetchIzobrazevanjeJavnoAll = () => {
    return useQuery<IzobrazevanjeListType[], AxiosError>(["izobrazevanjaJavno"], async () => {
        try {
            return (await client.get(`izobrazevanje/javno-all`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
};

const useFetchIzobrazevanje = (izobrazevanjeId: number) => {
    return useQuery<IzobrazevanjeFormType, AxiosError>(["izobrazevanje", izobrazevanjeId], async () => {
        try {
            return (await client.get(`izobrazevanje/${izobrazevanjeId}`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
};

const useFetchIzobrazevanjeDetail = (izobrazevanjeId: number) => {
    return useQuery<IzobrazevanjeDetailType, AxiosError>(["izobrazevanje", izobrazevanjeId], async () => {
        try {
            return (await client.get(`izobrazevanje/detail/${izobrazevanjeId}`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
};

// const useFetchIzobrazevanjeDetail = <T extends object>(izobrazevanjeId: number) => {
//     return useQuery<T, AxiosError>(["izobrazevanje", izobrazevanjeId], async () => {
//         try {
//             return (await client.get<T>(`izobrazevanje/detail/${izobrazevanjeId}`)).data;
//         }
//         catch (error) {
//             return Promise.reject(error);
//         }
//     });
// };


const useFetchIzobrazevanjeWithSifranti = (izobrazevanjeId: number) => {
    return useQuery<IzobrazevanjeWithSifrantiType, AxiosError>(["izobrazevanjeWithSifranti", izobrazevanjeId], async () => {
        try {
            return (await client.get(`izobrazevanje/withSifranti/${izobrazevanjeId}`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
};

const useAddIzobrazevanjeDraft = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<
        AxiosResponse,
        AxiosError,
        { izobrazevanje: IzobrazevanjeFormType; onSuccessCallback?: (izobrazevanje: IzobrazevanjeFormType) => Promise<void> }>(async ({ izobrazevanje }) => {
            console.log("useAddIzobrazevanjeDraft call");
            try {
                //let formData = getFormDataFromObject<IzobrazevanjeFormType>(izobrazevanje);
                //return (await client.post(`izobrazevanje`, formData)).data.izobrazevanjeId;
                return (await client.post(`izobrazevanje`, izobrazevanje));
            }
            catch (error) {
                return Promise.reject(error);
            }
        }, {
            onSuccess: async (response, variables) => {
                console.log("useAddIzobrazevanjeDraft.response", response);
                //const izobrazevanjeId = response.data.izobrazevanjeId;
                const izobrazevanjeRet: IzobrazevanjeFormType = {...response.data, eCourseSkupinaId: response.data.SkupinaId ?? null};

                if (variables.onSuccessCallback) {
                    await variables.onSuccessCallback(izobrazevanjeRet);
                }

                queryClient.invalidateQueries(["izobrazevanja"]);
                queryClient.invalidateQueries(["izobrazevanjeWithSifranti"]);

                nav(`/izobrazevanje/edit/${izobrazevanjeRet.izobrazevanjeId}`);
                if (displayFeedback)
                    displayFeedback("Izobraževanje je bilo uspešno dodano.", Status.SUCCESS);
            },
            onError: (err) => {
                // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
                let errMsg = "Prišlo je do napake."
                let apiException = getApiExceptionObjectFromAxiosError(err);
                if (apiException?.Message)
                    errMsg = apiException.Message;

                if (displayFeedback)
                    displayFeedback(errMsg, Status.ERROR)
            },
        });
};

// const useAddIzobrazevanjePublish = () => {
//     const { displayFeedback } = useContext(FeedbackContext);
//     const nav = useNavigate();
//     const queryClient = useQueryClient();
//     return useMutation<AxiosResponse, AxiosError, IzobrazevanjeFormType>(async (izobrazevanje) => {
//         try {
//             // let formData = getFormDataFromObject(izobrazevanje);
//             // return (await client.post(`izobrazevanje/publish`, formData));
//             return (await client.post(`izobrazevanje/publish`, izobrazevanje));
//         }
//         catch (error) {
//             return Promise.reject(error);
//         }
//         // try {
//         //     return (await client.post(`izobrazevanje/publish`, izobrazevanje));
//         // }
//         // catch (error) {
//         //     return Promise.reject(error);
//         // }
//     }, {
//         onSuccess: () => {
//             queryClient.invalidateQueries(["izobrazevanja"]);
//             nav(`/izobrazevanje/list`);
//             if (displayFeedback)
//                 displayFeedback("Izobraževanje je bilo uspešno aktivirano.", Status.SUCCESS)
//         },
//         onError: (err) => {
//             // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
//             if (displayFeedback)
//                 displayFeedback("Prišlo je do napake.", Status.ERROR)
//         }
//     });
// };

const useUpdateIzobrazevanjeDraft = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const queryClient = useQueryClient();
    return useMutation<
        AxiosResponse, 
        AxiosError,
        { izobrazevanje: IzobrazevanjeFormType; onSuccessCallback?: (izobrazevanje: IzobrazevanjeFormType) => Promise<void> }>(async ({ izobrazevanje }) => {
        try {
            console.log("useUpdateIzobrazevanjeDraft -izobrazevanje:", izobrazevanje);
            // let formData = getFormDataFromObject(izobrazevanje);
            // return (await client.put(`izobrazevanje/${izobrazevanje.izobrazevanjeId}`, formData));
            return (await client.put(`izobrazevanje/${izobrazevanje.izobrazevanjeId}`, izobrazevanje));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: async (response, variables) => {
            console.log("useUpdateIzobrazevanjeDraft.response", response);

            const izobrazevanjeRet: IzobrazevanjeFormType = {...response.data, eCourseSkupinaId: response.data.SkupinaId ?? null};

            if (variables.onSuccessCallback) {
                await variables.onSuccessCallback(izobrazevanjeRet);
            }
            queryClient.invalidateQueries(["izobrazevanja"]);
            queryClient.invalidateQueries(["izobrazevanjeWithSifranti"]);
            // nav(`/izobrazevanje/list`);
            if (displayFeedback)
                displayFeedback("Izobraževanje je bilo uspešno urejeno.", Status.SUCCESS)
        },
        onError: (err) => {
            let errMsg = "Prišlo je do napake."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        }
    });
};

const useUpdateIzobrazevanjePublish = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<
        AxiosResponse,
        AxiosError,
        { izobrazevanje: IzobrazevanjeFormType; onSuccessCallback?: (izobrazevanje: IzobrazevanjeFormType) => Promise<void> }>(async ({ izobrazevanje }) => {
        try {
            // let formData = getFormDataFromObject(izobrazevanje);
            // return (await client.put(`izobrazevanje/publish/${izobrazevanje.izobrazevanjeId}`, formData));
            return (await client.put(`izobrazevanje/publish/${izobrazevanje.izobrazevanjeId}`, izobrazevanje));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: async (response, variables) => {
            console.log("useUpdateIzobrazevanjePublish.response", response);
            //const izobrazevanjeId = response.data.izobrazevanjeId;
            const izobrazevanjeRet: IzobrazevanjeFormType = {...response.data, eCourseSkupinaId: response.data.SkupinaId ?? null};

            if (variables.onSuccessCallback) {
                await variables.onSuccessCallback(izobrazevanjeRet);
            }
            queryClient.invalidateQueries(["izobrazevanja"]);
            queryClient.invalidateQueries(["izobrazevanjeWithSifranti"]);
            //nav(`/izobrazevanje/list`);
            if (displayFeedback)
                displayFeedback("Izobraževanje je bilo uspešno urejeno in aktivirano.", Status.SUCCESS)
        },
        onError: (err) => {
            let errMsg = "Prišlo je do napake."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        }
    });
};

const useECourseToActive = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    return useMutation<AxiosResponse, AxiosError, number>(async (izobrazevanjeId) => {
        try {
            return (await client.put(`izobrazevanje/eCoursrToActive/${izobrazevanjeId}`, null));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: (_, izobrazevanjeId) => {
            //queryClient.invalidateQueries(["izobrazevanja"]);
            if (displayFeedback)
                displayFeedback("Učilnica je bila uspešno aktivirana.", Status.SUCCESS)
        },
        onError: (err) => {
            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback("Prišlo je do napake.", Status.ERROR)
        }
    }
    );
};

const useECourseToDraft = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    return useMutation<AxiosResponse, AxiosError, number>(async (izobrazevanjeId) => {
        try {
            return (await client.put(`izobrazevanje/eCoursrToDraft/${izobrazevanjeId}`, null));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: (_, izobrazevanjeId) => {
            //queryClient.invalidateQueries(["izobrazevanja"]);
            if (displayFeedback)
                displayFeedback("Učilnica je bila uspešno deaktivirana.", Status.SUCCESS)
        },
        onError: (err) => {
            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback("Prišlo je do napake.", Status.ERROR)
        }
    }
    );
};

const useDeactivateIzobrazevanje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    return useMutation<AxiosResponse, AxiosError, number>(async (izobrazevanjeId) => {
        try {
            return (await client.put(`izobrazevanje/deactivate/${izobrazevanjeId}`, null));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: (_, izobrazevanjeId) => {
            //queryClient.invalidateQueries(["izobrazevanja"]);
            nav(`/izobrazevanje/edit/${izobrazevanjeId}`);
            if (displayFeedback)
                displayFeedback("Izobraževanje je bilo uspešno deaktivirano.", Status.SUCCESS)
        },
        onError: (err) => {
            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback("Prišlo je do napake.", Status.ERROR)
        }
    }
    );
};

const useDeleteIzobrazevanje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, IzobrazevanjeFormType>(async (izobrazevanje) => {
        try {
            return (await client.delete(`izobrazevanje/${izobrazevanje.izobrazevanjeId}`));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: (request, variables) => {
            console.log("useDeleteIzobrazevanje - request", request);
            console.log("useDeleteIzobrazevanje - variables", variables);
            queryClient.invalidateQueries(["izobrazevanja"]);
            if (variables.vrsta === IzobrazevanjeVrsta.Javno)
                 nav(`/izobrazevanje/javno-list`);
            else
                nav(`/izobrazevanje/list`);
            if (displayFeedback)
                displayFeedback("Izobraževanje je bilo uspešno odstranjeno.", Status.SUCCESS)
        },
        onError: (err) => {
            if (displayFeedback)
                displayFeedback("Prišlo je do napake.", Status.ERROR)
        }
    }
    );
};

export default useFetchIzobrazevanjeAll;
export {
    useFetchIzobrazevanje,
    useFetchIzobrazevanjeAll,
    useFetchIzobrazevanjeJavnoAll,
    useFetchIzobrazevanjeWithSifranti,
    useFetchIzobrazevanjeDetail,
    useAddIzobrazevanjeDraft,
    //useAddIzobrazevanjePublish,
    useUpdateIzobrazevanjeDraft,
    useUpdateIzobrazevanjePublish,
    useECourseToActive,
    useECourseToDraft,
    useDeactivateIzobrazevanje,
    useDeleteIzobrazevanje
};